module.exports = __webpack_public_path__ + "static/SctoGroteskARegular-93cdad39d3ea2f9b37b403665a006419.woff";